export const tableCellHeadStyle = {
  fontWeight: 600,
  minWidth: "100px",
};
